export default __webpack_public_path__ + "static/media/70.8d14fe64.png";